export default __webpack_public_path__ + "static/guestPostGuidelines-26bc44a1a608a5ceacd3dcc0ecc403ab.pdf";